import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { GungTextInputComponent } from '../gung-text-input/gung-text-input.component';

@Component({
    selector: 'lib-gung-checkbox-input',
    templateUrl: './gung-checkbox-input.component.html',
    styleUrls: ['./gung-checkbox-input.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GungCheckboxInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class GungCheckboxInputComponent extends GungTextInputComponent {
  @Input()
  public labelClass: string | string[];

  @Input()
  public divClass: string | string[];

  @Input()
  public useYesNo = false;

  @Input()
  public labelAfter = false;
}
